<ng-container *transloco="let t" class="container">
  <div class="border-2">
  <div class="modal-wrapper">
    <div class="p-5 blur">
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
    <div class="modal-body">
      <div class="d-flex justify-content-center">
        <div class="min-width-400">
<!--          <img  src="assets/img/svg/logo_header_row_red-01.svg" alt="" style="scale: 20%">-->
        </div>
      </div>
      <h3 class="text-center"
          style="
            color: white;
            font-weight: lighter;
            opacity: 0.9;
            font: 15px">{{t("app.store.info.app")}}</h3>
        <h1 class="text-uppercase text-center" style="
        color: white;
        font-weight: lighter;
        opacity: 0.9;
        font-size: -webkit-xxx-large;">{{t("app.store.info.comming.soon").toUpperCase()}}</h1>
            <div class="progress-wrapper">
              <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"

                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            </div>

        <div class="pt-2 text-center bottom-text-wrapper">
          <span  class="bottom-text">{{t("app.store.info")}}</span>
        </div>


    </div>
    <div class="modal-footer p-5">

      <app-button (click)="activeModal.close('Close click')" [label]="t('app.common.go.back')"
        [btnClass]="'btn-primary-red btn-large'"/>

    </div>
  </div>
  </div>
</div>
</ng-container>
